import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";

@Component({
    selector: 'app-component-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css']
})

export class FooterComponent implements OnInit {
    @ViewChild('tablist') navEl: ElementRef;
    isMobile = window.innerWidth < 1000 ? true : false;
    constructor() {}
    ngOnInit() {}
    onResize(event: any) {
        this.isMobile = window.innerWidth < 1000 ? true : false;
    }
}